import { Component } from '@angular/core';

@Component({
  selector: 'sca-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss']
})
export class ListViewComponent {

}
